'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { withRouter } from 'react-router-dom';
import { EntityTypes } from 'AdsUI/lib/Constants';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import ScopeWrapper from 'AdsUI/components/ScopeWrapper';
import { AdSequenceSteps } from 'AdsUI/records/ad-management/AdCreationRecord';
import keyMirror from 'react-utils/keyMirror';
const SEQUENCES_PAGE = '/sequences';
const SEQUENCE_STEPS_MAPPING = {
  [EntityTypes.AD_SEQ_CAMPAIGNS_ATTRACT_STAGE]: AdSequenceSteps.ATTRACT,
  [EntityTypes.AD_SEQ_CAMPAIGNS_CONVERT_STAGE]: AdSequenceSteps.CONVERT,
  [EntityTypes.AD_SEQ_CAMPAIGNS_CLOSE_STAGE]: AdSequenceSteps.CLOSE
};
const SEQ_ENTITY_TYPES = keyMirror({
  [EntityTypes.AD_SEQ_CAMPAIGNS_ATTRACT_STAGE]: null,
  [EntityTypes.AD_SEQ_CAMPAIGNS_CONVERT_STAGE]: null,
  [EntityTypes.AD_SEQ_CAMPAIGNS_CLOSE_STAGE]: null
});

const CampaignManagementButtons = ({
  adAccount,
  entityType,
  campaignEntity,
  parent,
  entity,
  history,
  match: {
    params
  },
  location,
  sequenceStep
}) => {
  const {
    pathname
  } = location;
  const isSequencesPage = SEQUENCES_PAGE === pathname;
  const editAdSeqeunce = useCallback(() => {
    const {
      sequenceId
    } = params;
    const step = sequenceStep && SEQUENCE_STEPS_MAPPING[sequenceStep] || AdSequenceSteps.ATTRACT;
    history.push(`/campaigns/${adAccount.network.toLowerCase()}/sequence/edit/${sequenceId || entity.id}/${step}`);
  }, [adAccount, entity, history, params, sequenceStep]);
  const openManagementPanel = useCallback(() => {
    const rootPathname = location.pathname === '/' ? '' : location.pathname;

    switch (entityType) {
      case EntityTypes.CAMPAIGN:
      case EntityTypes.SEQUENCE:
        {
          history.push(`/manage/${adAccount.network.toLowerCase()}/${adAccount.accountId}/campaigns/${campaignEntity.id}`);
          break;
        }

      case EntityTypes.ADGROUP:
        {
          history.push(`${rootPathname}/adgroups/${entity.id}/manage`);
          break;
        }

      case EntityTypes.AD:
        {
          history.push(`${rootPathname}/ads/${entity.id}/manage`);
          break;
        }

      case EntityTypes.KEYWORD:
        {
          history.push(`/accounts/${adAccount.network.toLowerCase()}/${adAccount.accountId}/campaigns/${campaignEntity.id}/adgroups/${parent.id}/keywords/${entity.id}/manage`);
          break;
        }

      default:
        {
          break;
        }
    }
  }, [adAccount, campaignEntity, parent, entity, entityType, history, location]);
  const editEntity = useCallback(() => {
    switch (entityType) {
      case EntityTypes.CAMPAIGN:
        {
          history.push(`/${adAccount.network.toLowerCase()}/${adAccount.accountId}/campaigns/${campaignEntity.id}/edit/details`);
          break;
        }

      case EntityTypes.ADGROUP:
        {
          history.push(`/${adAccount.network.toLowerCase()}/${adAccount.accountId}/campaigns/${campaignEntity.id}/adgroups/${entity.id}/edit/details`);
          break;
        }

      case EntityTypes.AD:
        {
          history.push(`/${adAccount.network.toLowerCase()}/${adAccount.accountId}/campaigns/${campaignEntity.id}/adgroups/${parent.id}/ad/${entity.id}/edit/details`);
          break;
        }

      default:
        {
          break;
        }
    }
  }, [entityType, adAccount, campaignEntity, history, entity, parent]);

  const handleEditButton = () => {
    usageTracker.track('modifyCampaign', {
      action: 'Clicked edit button',
      entityType,
      network: adAccount.network
    });

    if (isSequencesPage || SEQ_ENTITY_TYPES[sequenceStep]) {
      editAdSeqeunce();
    } else if ([EntityTypes.AD, EntityTypes.ADGROUP, EntityTypes.CAMPAIGN].includes(entityType)) {
      editEntity();
    } else {
      openManagementPanel();
    }
  };

  const handleViewButton = () => {
    usageTracker.track('modifyCampaign', {
      action: 'Clicked view details button',
      entityType,
      network: adAccount.network
    });
    openManagementPanel();
  };

  if (entityType === EntityTypes.KEYWORD) {
    return /*#__PURE__*/_jsx(ScopeWrapper, {
      tooltipKey: "editKeywords",
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        size: "extra-small",
        onClick: handleEditButton,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editButton"
        })
      })
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [entityType !== EntityTypes.CAMPAIGN && /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      size: "extra-small",
      onClick: handleEditButton,
      "data-test-id": "edit-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editButton"
      })
    }), !isSequencesPage && /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      size: "extra-small",
      onClick: handleViewButton,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.management.viewDetails"
      })
    })]
  });
};

export default withRouter(CampaignManagementButtons);